import React, { useEffect, useState } from "react";

const SendDmModal = ({ isOpen, onClose, contactName, companyName, handleSendMessage, selectedContact }) => {
    const [text, setText] = useState("");

    useEffect(() => {
        console.log("Selected Contact: ", selectedContact)
        // When the modal opens, update the text with the new contact's info
        if (isOpen) {
            setText(`Hi ${contactName}, I am really inspired by your work recruiting top talent at ${companyName}. I'd love to connect and follow more of your insights here on LinkedIn.`);
        }
    }, [isOpen, contactName, companyName]);

    const handleSubmit = () => {
        if (!selectedContact) {
            console.error("No contact selected to send a message to.");
            return;
        }

        handleSendMessage(
            selectedContact.accountId,
            selectedContact.providerId,
            text,
            selectedContact.userId
        );

        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-lg">
                <h2 className="text-lg font-semibold mb-4">Enter your message</h2>
                <textarea
                    className="w-full border rounded p-2 h-32 resize-none"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    placeholder="Type something..."
                />

                <div className="flex justify-end gap-2 mt-4">
                    <button
                        className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                        onClick={handleSubmit}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SendDmModal;
